<template>
  <kendo-window
      ref="kendoWindowRef"
      :title="'업로드 결과'"
      :modal="true"
      :width="'700px'"
      :scrollable="true"
      @close="$emit('onClose')"
      style="display:none;">
    <template>
      <div class="pop-container">
        <div class="pop-conts">
          <div class="box_flex tab ">
            <li class="txt_c">업로드 항목 : <b>{{ resultData.totalCnt }}</b></li>
            <li class="txt_c">업로드 성공 : <b class="txt_g">{{ resultData.uploadSuccessCnt }}</b></li>
            <li class="txt_c mg0"><span class="txt_o">업로드 실패 : {{ resultData.uploadFailCnt }} </span></li>
          </div>
          <div class="f_r mb10">
            <button v-show="!!resultData.uploadFailCnt && resultData.uploadFailCnt>0" type="button" class="mid_btn" @click="failDownload" >
              <span><span class="k-icon k-i-download "></span>실패 목록 다운로드</span>
            </button>
          </div>
          <kendo-grid ref="errorGridRef"
                      style="cursor: pointer;"
                      class="basic_table mt10"
                      :data-source="getErrorDataSource"
                      :columns="errorListColumns"
                      :filterable="false"
                      :sortable="false"
                      :scrollable="true"
                      :pageable-always-visible="false"
                      :reorderable="true"
                      :column-menu="false"
                      :resizable="true"
                      :selectable="'multiple row'"
                      :noRecords="{ template: '<div class=\'gridNoData\' style=\'text-align: center;\'>표시할 데이터가 없습니다.</div>' }">
          </kendo-grid>
          <div class="k-text-center mgt30 button_area">
            <button type="button" id="buttonCancel" class="large_btn orange" @click="onClickClose">확인</button>
          </div>
        </div>
      </div>
    </template>
  </kendo-window>
</template>

<script>
import EtnersCommonUtil from "@/common/etners.common.util";
import * as XLSX from "xlsx"
import * as FileSaver from 'file-saver'

export default {
  name: "ExcelUploadResultWindow",
  props: {
    resultData : {
      type : Object,
      required : false,
      default : function (){
        return {}
      }
    },
    uploadData : {
      type : Array,
      required : false,
      default : function (){
        return []
      }
    },
  },
  computed: {
    getErrorDataSource () {
      if (EtnersCommonUtil.isEmpty(this.resultData)) {
        return []
      }
      const failMsgInfoList = this.resultData.failMsgInfoList
      let rowNumber = 1
      if (failMsgInfoList === null) {
        return false
      }
      for (let i = 0; i < failMsgInfoList.length; i++) {
        const row = failMsgInfoList[i]
        row.rowNumber = rowNumber++
      }
      return failMsgInfoList
    },
  },
  methods: {
    failDownload () {
      const vm = this
      setTimeout(function (){
        // 실패 목록 출력
        const rowsToExclude = vm.resultData.failIndexList.map(item => item)
        let filteredData = vm.uploadData.filter((row, rowIndex) => rowsToExclude.includes(rowIndex))
        filteredData.forEach(item => item.No = null)

        // json 파일 엑셀로 변환
        const newWorkSheet = XLSX.utils.json_to_sheet(filteredData)
        const newWorkbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(newWorkbook, newWorkSheet, '사내 물류 (파우치) 엑셀 업로드 양식')

        // 엑셀 다운로드
        const blob = XLSX.write(newWorkbook, {bookType: 'xlsx', type: 'binary'})
        FileSaver.saveAs(new Blob([s2ab(blob)], { type: 'application/octet-stream' }), `파우치관리_업로드_실패_데이터.xlsx`)

        function s2ab(s) {
          const buf = new ArrayBuffer(s.length)
          const view = new Uint8Array(buf)
          for (let i = 0; i < s.length; i++) {
            view[i] = s.charCodeAt(i) & 0xFF
          }
          return buf
        }
      })
    },
    onClickClose (e) {
      const vm = this
      vm.$refs.kendoWindowRef.kendoWidget().close()
    },
  },
  data () {
    const kendoGridHeaderAttributes = {
      style: 'text-align : center;'
    }
    return {
      errorListColumns: [
        {
          field: 'line',
          title: '행 번호',
          width: '13%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
        },
        {
          field: 'reason',
          title: '오류',
          width: '',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>
